import React from 'react';
import './Privacy.css';

export const Privacy: React.FC = () => {
  return (
    <div className="privacy">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last updated: April 1, 2026</p>

        <section>
          <h2>Who We Are</h2>
          <p>
            PracticalMedia.com is a developer-first publishing platform focused on indie game development.
            This policy explains how we collect, use, and protect your information when you visit our website.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>

          <h3>Information You Provide</h3>
          <p>When you use our contact form, we collect:</p>
          <ul>
            <li>Your name</li>
            <li>Email address</li>
            <li>Subject and message content</li>
          </ul>

          <h3>Information Collected Automatically</h3>
          <p>When you visit our site, our servers and analytics tools automatically collect:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and device information</li>
            <li>General geographic location (country and city level)</li>
            <li>Pages visited and time spent</li>
            <li>Referring website</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>To respond to your contact form submissions</li>
            <li>To monitor and improve site performance and security</li>
            <li>To understand how visitors use our site through analytics</li>
            <li>To detect and prevent abuse or unauthorized access</li>
          </ul>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          <p>We use the following third-party services that may collect data:</p>
          <ul>
            <li><strong>Google Analytics</strong>: collects anonymized usage data including pages visited, device type, and general location. See <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.</li>
            <li><strong>Resend</strong>: processes email notifications when you submit the contact form. See <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Resend's Privacy Policy</a>.</li>
            <li><strong>Cloudflare</strong>: provides hosting, CDN, and security services. See <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">Cloudflare's Privacy Policy</a>.</li>
          </ul>
        </section>

        <section>
          <h2>Data Retention</h2>
          <p>
            Contact form submissions are retained until they are no longer needed for their purpose.
            Server request logs (IP address, pages visited, timestamps) are retained for up to 90 days
            and then automatically deleted.
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            We do not set any first-party cookies. Third-party services such as Google Analytics may
            set their own cookies. You can control cookie behavior through your browser settings.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request access to the personal data we hold about you</li>
            <li>Request deletion of your personal data</li>
            <li>Opt out of analytics tracking by using browser extensions or Do Not Track settings</li>
          </ul>
          <p>
            To exercise these rights, please contact us at{' '}
            <a href="mailto:joseph@practicalmedia.com">joseph@practicalmedia.com</a>.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this policy from time to time. Changes will be reflected on this page
            with an updated date.
          </p>
        </section>
      </div>
    </div>
  );
};
